/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import { PopPupChung } from '../../../component/PopPupChung'
import { useState } from 'react'
import './ChamSocKhachHang.scss'

function ChamSocKhachHang ({ isOpen, setisOpen }) {
  const [animateOut, setAnimateOut] = useState(false)
  const handleClose = () => {
    setAnimateOut(true)
  }

  return (
    <PopPupChung
      isOpen={isOpen}
      setisOpen={setisOpen}
      animateOut={animateOut}
      setAnimateOut={setAnimateOut}
      paddingnone={true}
    >
      <div className='service_cskh_title'>
        <span onClick={handleClose}></span>
      </div>
      <div className='service_cskh_content'>
        <div className='service_cskh_content_item'>
          <span className='service_cskh_content_item_icon'></span>
          <span className='service_cskh_content_item_text'>CSKH 1</span>
          <a href="https://t.me/qk88ad" className='service_cskh_content_item_a'>
            ติดต่อ
            <span className='service_cskh_content_item_lh'></span>
          </a>
        </div>
        <div className='service_cskh_content_item'>
          <span className='service_cskh_content_item_icon'></span>
          <span className='service_cskh_content_item_text'>CSKH 2</span>
          <a href="https://t.me/qk88cskh2" className='service_cskh_content_item_a'>
            ติดต่อ
            <span className='service_cskh_content_item_lh'></span>
          </a>
        </div>
      </div>
    </PopPupChung>
  )
}

export default ChamSocKhachHang
